import { createVfm } from 'vue-final-modal';

export default defineNuxtPlugin(nuxt => {
    const vfm = createVfm();
    nuxt.vueApp.use(vfm as any);
});
